import mixpanel from "mixpanel-browser";
import { ANALYTICS_EVENTS } from "../../../constants/analyticsEvents.constants";

const envToken = process.env.REACT_APP_MIXPANEL_TOKEN;
const experimentToken = process.env.REACT_APP_MIXPANEL_EXPERIMENT_TOKEN;
const isLocalhost = window.location.hostname === "localhost";

if (envToken) {
  mixpanel.init(
    envToken,
    {
      debug: isLocalhost,
      track_pageview: true,
    },
    ANALYTICS_EVENTS.MIXPANEL.ENV_INSTANCE
  );
}

if (experimentToken) {
  mixpanel.init(
    experimentToken,
    {
      debug: isLocalhost,
      track_pageview: true,
    },
    ANALYTICS_EVENTS.MIXPANEL.EXPERIMENT_INSTANCE
  );
}

export default mixpanel;